import {
  _30_MIN_INDIVIDUAL_90832,
  DIAGNOSTIC_INTERVIEW_90792,
} from "@/components/Provider/ScheduleAvailability/constants";

export const providerTypeToDefaultNoteEventType = (provider) => {
  switch (provider.provider_type) {
    case "BEHAVIORAL":
      return _30_MIN_INDIVIDUAL_90832;

    case "BEHAVIORAL_INTAKE":
      return _30_MIN_INDIVIDUAL_90832;

    case "PRESCRIBE":
      return DIAGNOSTIC_INTERVIEW_90792;

    default:
      return _30_MIN_INDIVIDUAL_90832;
  }
};
